import { defaultSelectBestPackage, PSSizeMode } from "~/utils/cartHelper";
import { INVALID_PACKAGE_CODE } from "~/utils/constants";
import { type PackCodeProvider } from "~/features/addToCart/hooks/useAddToCartNew";

export const makeSalesAwarePackCodeProvider =
  (restrictionQuery: string | null, includeSoldOut = true): PackCodeProvider =>
  (productDescriptor, quantity) => {
    let allPackages = productDescriptor.availability!.packagingInformation;
    if (restrictionQuery) {
      allPackages = allPackages.filter((p) => p.packCode === restrictionQuery);
    }
    return (
      defaultSelectBestPackage(
        quantity,
        allPackages.map((p) => p.packCode),
        productDescriptor,
        PSSizeMode.SMALLEST_FIRST,
        includeSoldOut,
      )?.packCode ?? INVALID_PACKAGE_CODE
    );
  };
